import io from 'socket.io-client';
import { Modal } from 'bootstrap';

let socket;

if ('development' === process.env.NODE_ENV) {
    socket = io('http://' + window.location.hostname + ':3000');
} else {
    socket = io('https://domek.kjaniszewski.pl/', {
        path: '/node/socket.io'
    });
}

$(function () {
    let $main = $('body .main'),
        clearCurrentCardTime = 1E3;

    // Potwierdzenie usunięcia (modal zamiast natywnego confirm())
    let $confirmDeleteModal = $('#confirmDeleteModal'),
        confirmDeleteModal = $confirmDeleteModal.length ? new Modal($confirmDeleteModal.get(0)) : null,
        $pendingDeleteForm = null;

    $(document).on('submit', '.delete-form', function (e) {
        if (!confirmDeleteModal || $(this).data('confirmed')) {
            return;
        }

        e.preventDefault();
        $pendingDeleteForm = $(this);
        $confirmDeleteModal.find('.confirm-message').text($(this).data('confirm') || 'Na pewno usunąć?');
        confirmDeleteModal.show();
    });

    $confirmDeleteModal.on('click', '.confirm-delete-button', () => {
        if ($pendingDeleteForm) {
            $pendingDeleteForm.data('confirmed', true);
            $pendingDeleteForm.get(0).submit();
            $pendingDeleteForm = null;
        }

        confirmDeleteModal.hide();
    });

    // Przechowywanie - inline edycja rzeczy
    if (/^\/storage\/\d+\/edit$/.test(window.location.pathname)) {
        let $thingsList = $main.find('[data-things-list]'),
            token = $thingsList.data('token');

        function setThingRowMode($li, editing) {
            $li.find('.thing-view').toggleClass('d-none', editing);
            $li.find('.thing-edit-row').toggleClass('d-none', !editing).toggleClass('d-flex', editing);
        }

        function saveThing($li) {
            let thingId = $li.data('thing-id'),
                $input = $li.find('.thing-edit-input'),
                name = $input.val().trim();

            if ('' === name) {
                $input.trigger('focus');
                return;
            }

            $.post({
                url: '/storage/thing/' + thingId + '/edit',
                data: {name, _token: token},
                dataType: 'json'
            }).done((thing) => {
                $li.find('.thing-name').text(thing.name);
                $li.find('.delete-form').data('confirm', 'Na pewno usunąć „' + thing.name + '”?');
                setThingRowMode($li, false);
            }).fail(() => {
                $input.trigger('focus');
            });
        }

        $main.on('click', '.thing-edit-trigger', (e) => {
            e.preventDefault();
            let $li = $(e.currentTarget).closest('li');

            $li.find('.thing-edit-input').val($li.find('.thing-name').text());
            setThingRowMode($li, true);
            $li.find('.thing-edit-input').trigger('focus').get(0).select();
        });

        $main.on('click', '.thing-cancel', (e) => {
            setThingRowMode($(e.currentTarget).closest('li'), false);
        });

        $main.on('click', '.thing-save', (e) => {
            saveThing($(e.currentTarget).closest('li'));
        });

        $main.on('keydown', '.thing-edit-input', (e) => {
            if ('Enter' === e.key) {
                e.preventDefault();
                saveThing($(e.currentTarget).closest('li'));
            } else if ('Escape' === e.key) {
                setThingRowMode($(e.currentTarget).closest('li'), false);
            }
        });
    }

    // strona główna
    if (window.location.pathname === '/') {
        let $currentCard = null;

        const rangeInputs = document.querySelectorAll('.card input[type="range"]');

        rangeInputs.forEach(input => {
            $(input).rangeslider({
                polyfill: false
            });
        });

        $main.on('click', '.card:not([data-state="unavailable"]):not(.air-filter)', (e) => {
            let $card = $(e.target);

            if (!$card.hasClass('card')) {
                if ($card.is('input[type="range"]')) {
                    return;
                }

                $card = $card.parents('.card');
            }

            let $checkbox = $card.find('[type=checkbox]');

            $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
        });
        $main.on('click', '.card.air-filter:not([data-state="unavailable"]) .toggle', (e) => {
            let $card = $(e.target).parents('.card'),
                $checkbox = $card.find('[type=checkbox]');

            $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
        });
        $main.on('change', '.card input[type="checkbox"]', (e) => {
            let $checkbox = $(e.target),
                tuyaId = $checkbox.data('id'),
                $card = $checkbox.parents('.card'),
                state = $checkbox.prop('checked');

            $currentCard = $card;

            toggleCardState($card, state);
            syncAirFilterPowerSwitch($card.data('id'), state);
            socket.emit('switch', {'id': $card.data('id'), state});

            let onOff = $checkbox.prop('checked') ? 'on' : 'off';

            apiPost('/api/switch/' + onOff, {tuyaId})
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    return response.json();
                })
                .then(() => {
                    setTimeout(function () {
                        $currentCard = null;
                    }, clearCurrentCardTime);
                })
                .catch(() => toggleCardState($card));
        });
        $main.on('input', '.card input[type="range"]', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let $checkbox = $(e.target),
                $card = $checkbox.parents('.card'),
                brightness = $checkbox.val();

            $currentCard = $card;
            setBrightness($card, brightness);
            socket.emit('brightness', {'id': $card.data('id'), brightness});
        });
        $main.on('change', '.card input[type="range"]', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let $checkbox = $(e.target),
                $card = $checkbox.parents('.card'),
                state = $card.find('input[type="checkbox"]').prop('checked');

            $currentCard = null;
            sendBrightness($card, state);
        });
        $main.on('click', '.card input[type="range"] ~ .rangeslider', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let $checkbox = $(e.target),
                $card = $checkbox.parents('.card'),
                state = $card.find('input[type="checkbox"]').prop('checked');

            $currentCard = null;
            sendBrightness($card, state);
        });
        $main.on('click', '.card.room:not([data-state="unavailable"])', (e) => {
            let $card = $(e.target);

            if (!$card.hasClass('card')) {
                if ($card.hasClass('open')) {
                    return;
                }

                $card = $card.parents('.card');
            }

            let divOffset = $card.offset(),
                divWidth = $card.width(),
                clickX = e.pageX - divOffset.left;

            if (clickX >= divWidth - 100) {
                return;
            }

            toggleCardState($card);
            socket.emit('switch', {'id': $card.data('id'), 'state': $card.data('state') === 'on'});
            let newState = $card.data('state') === 'on';

            $main.find('[data-room="' + $card.data('id') + '"]:not([data-state="unavailable"])').each((i, e) => {
                $(e).find('input[type="checkbox"]').prop('checked', newState).trigger('change');
            });
        });
        $main.on('click', '.card.room .open', (e) => {
            let $card = $(e.target).parents('.card'),
                open = !$card.data('open');

            $card.attr('data-open', open).data('open', open);

            let $roomDiv = $card.next();
            if (!$roomDiv.hasClass('row')) {
                return;
            }

            if (open) {
                $roomDiv.fadeIn();
            } else {
                $roomDiv.fadeOut(() => {
                    $roomDiv.hide();
                });
            }
        });

        socket.on('serverSwitch', (data) => {
            $currentCard = $main.find('.card[data-id="' + data.id + '"]');
            toggleCardState($currentCard, data.state);
            syncAirFilterPowerSwitch(data.id, data.state);

            setTimeout(function () {
                $currentCard = null;
            }, clearCurrentCardTime);
        });
        socket.on('serverBrightness', (data) => {
            $currentCard = $main.find('.card[data-id="' + data.id + '"]');
            setBrightness($currentCard, data.brightness);

            setTimeout(function () {
                $currentCard = null;
            }, clearCurrentCardTime);
        });

        function openAirFilterModal($card) {
            fetch('/api/air-filter/' + $card.data('id'), {method: 'GET'})
                .then(response => response.text())
                .then(function (html) {
                    let $modal = $main.find('#deviceModal');
                    $modal.find('.modal-content').html(html);
                    new Modal($modal.get(0)).show();

                    let fanSpeed = $modal.find('.modal-title').attr('data-fan-speed');
                    if (fanSpeed) {
                        applyFanSpeed($card.data('id'), fanSpeed);
                    }
                });
        }

        function applyFanSpeed(tuyaId, fanSpeed) {
            if (!fanSpeed) {
                return;
            }

            $main.find('#deviceModal .modal-title[data-id="' + tuyaId + '"]').attr('data-fan-speed', fanSpeed);
            $main.find('.card.air-filter[data-id="' + tuyaId + '"]').attr('data-fan-speed', fanSpeed);
        }

        $main.on('click', '.card.air-filter:not([data-state="unavailable"]) .settings-icon', (e) => {
            openAirFilterModal($(e.target).parents('.card'));
        });

        function bindAirFilterButtonGroup(className, settingKey) {
            $main.on('click', '.air-filter-settings .' + className, (e) => {
                let $btn = $(e.currentTarget),
                    $group = $btn.siblings('.' + className).add($btn),
                    $previouslyActive = $group.filter('.active'),
                    $settings = $btn.closest('.air-filter-settings'),
                    tuyaId = $settings.data('id'),
                    value = $btn.data('value');

                $group.removeClass('active');
                $btn.addClass('active');

                if ('fanSpeed' === settingKey) {
                    applyFanSpeed(tuyaId, value);
                }

                patchAirFilterSettings(tuyaId, {[settingKey]: value})
                    .catch(() => {
                        $group.removeClass('active');
                        $previouslyActive.addClass('active');
                    });
            });
        }

        bindAirFilterButtonGroup('mode', 'mode');
        bindAirFilterButtonGroup('countdown', 'countdown');
        bindAirFilterButtonGroup('fan-speed', 'fanSpeed');
        bindAirFilterButtonGroup('auto-mode', 'autoMode');
        $main.on('click', '#deviceModal .power-toggle', (e) => {
            let $icon = $(e.currentTarget),
                tuyaId = $icon.data('id'),
                $card = $main.find('.card.air-filter[data-id="' + tuyaId + '"]');

            $card.find('[type=checkbox]').prop('checked', !$icon.hasClass('on')).trigger('change');
        });
        $main.on('change', '.air-filter-settings .anion', (e) => {
            let $checkbox = $(e.currentTarget),
                tuyaId = $checkbox.closest('.air-filter-settings').data('id');

            patchAirFilterSettings(tuyaId, {anion: $checkbox.prop('checked')})
                .catch(() => $checkbox.prop('checked', !$checkbox.prop('checked')));
        });
        $main.on('change', '.air-filter-settings .child-lock', (e) => {
            let $checkbox = $(e.currentTarget),
                tuyaId = $checkbox.closest('.air-filter-settings').data('id');

            patchAirFilterSettings(tuyaId, {childLock: $checkbox.prop('checked')})
                .catch(() => $checkbox.prop('checked', !$checkbox.prop('checked')));
        });
        function patchAirFilterSettings(tuyaId, settings) {
            return fetch('/api/air-filter/' + tuyaId + '/settings', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(settings)
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return response.json();
            }).then((data) => {
                socket.emit('airFilterSettings', {id: tuyaId, settings});

                return data;
            });
        }

        function applyAirFilterSettings(tuyaId, settings) {
            if ('fanSpeed' in settings) {
                applyFanSpeed(tuyaId, settings.fanSpeed);
            }

            let $settings = $main.find('.air-filter-settings[data-id="' + tuyaId + '"]');

            if (!$settings.length) {
                return;
            }

            [
                ['mode', 'mode'],
                ['countdown', 'countdown'],
                ['fan-speed', 'fanSpeed'],
                ['auto-mode', 'autoMode']
            ].forEach(([className, settingKey]) => {
                if (!(settingKey in settings)) {
                    return;
                }

                let value = settingKey === 'countdown' ? (settings[settingKey] ?? 'cancel') : settings[settingKey];

                $settings.find('.' + className).removeClass('active');
                $settings.find('.' + className + '[data-value="' + value + '"]').addClass('active');
            });

            if ('anion' in settings) {
                $settings.find('.anion').prop('checked', settings.anion);
            }

            if ('childLock' in settings) {
                $settings.find('.child-lock').prop('checked', settings.childLock);
            }

            if ('filterLife' in settings) {
                $settings.find('.filter-life-value').text(settings.filterLife + '%');
                $settings.find('.filter-life-bar').css('width', settings.filterLife + '%');
            }
        }

        socket.on('serverAirFilterSettings', (data) => {
            applyAirFilterSettings(data.id, data.settings);
        });

        function syncAirFilterPowerSwitch(tuyaId, isOn) {
            $main.find('#deviceModal .power-toggle[data-id="' + tuyaId + '"]').toggleClass('on', isOn);
            $main.find('#deviceModal .modal-title[data-id="' + tuyaId + '"]').toggleClass('on', isOn);
        }

        setInterval(refreshDevices, 5000);

        function toggleCardState($card, state = null) {
            if (null === state) {
                state = $card.data('state') === 'off';
            }

            if (state) {
                $card.attr('data-state', 'on').data('state', 'on');
            } else {
                $card.attr('data-state', 'off').data('state', 'off');
            }
        }

        function refreshDevices() {
            apiGet('/api/rooms')
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    return response.json();
                })
                .then(rooms => {
                    $.each(rooms, (i, room) => {
                        let $card = $main.find('.room[data-id="' + room.id + '"]');
                        if (null === $currentCard || $card.data('id') !== $currentCard.data('id')) {
                            $card.attr('data-state', room.state).data('state', room.state);
                        }

                        $.each(room.devices, (i, e) => {
                            let $card = $main.find('.device[data-id="' + e.tuyaId + '"]');

                            if (null !== $currentCard && $card.data('id') === $currentCard.data('id')) {
                                return;
                            }

                            if ($card.attr('data-state') !== e.state) {
                                $card.attr('data-state', e.state).data('state', e.state);
                                $card.find('[type="checkbox"]').prop('checked', e.state === 'on');
                            }

                            if (e.brightness !== null) {
                                setBrightness($card, e.brightness);
                            }
                        });
                        $.each(room.thermometers, (i, e) => {
                            let $card = $main.find('.thermometer[data-id="' + e.id + '"]');
                            $card.find('.icon').html(e.icon);
                            $card.find('.temp .value').html(e.temp);
                            $card.find('.hum .value').html(e.hum);
                            $card.find('.time').html(e.time);
                        });
                        $.each(room.airFilters, (i, e) => {
                            let $card = $main.find('.air-filter[data-id="' + e.tuyaId + '"]');

                            if (null !== $currentCard && $card.data('id') === $currentCard.data('id')) {
                                return;
                            }

                            if ($card.attr('data-state') !== e.state) {
                                $card.attr('data-state', e.state).data('state', e.state);
                                $card.find('[type="checkbox"]').prop('checked', e.state === 'on');
                            }

                            syncAirFilterPowerSwitch(e.tuyaId, e.state === 'on');

                            if ($card.attr('data-quality') !== e.quality) {
                                $card.attr('data-quality', e.quality).data('quality', e.quality);
                            }

                            $card.find('.pm .value').html(e.pm);
                            $card.find('.temp .value').html(e.temp);
                            $card.find('.hum .value').html(e.hum);

                            applyAirFilterSettings(e.tuyaId, e);
                        });
                    })
                });
        }

        function setBrightness($card, brightness) {
            let classes = $card.attr('class').split(' ');

            $card.find('.state .on .brightness').html(' ' + brightness + '%');

            for (let i = 0; i < classes.length; i++) {
                if (classes[i].startsWith('brightness-')) {
                    $card.removeClass(classes[i]);
                }
            }

            $card.addClass('brightness-' + brightness);
            $card.find('input[type="range"]').val(brightness);
        }

        function getBrightness($card) {
            let brightness = parseInt($card.find('.state .on .brightness').html());

            if (brightness <= 0 || isNaN(brightness)) {
                return 100;
            }

            return brightness;
        }

        function sendBrightness($card, state) {
            let brightness = getBrightness($card),
                tuyaId = $card.data('id');

            socket.emit('brightness', {'id': tuyaId, brightness});
            apiPost('/api/set/brightness', {tuyaId, brightness, state})
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    return response.json();
                });
        }
    }

    // Historia
    if (window.location.pathname === '/history') {
        let $historyTable = $main.find('#history-table'),
            columns = [
                {data: 'thermometer.name'},
                {data: 'temp'},
                {data: 'hum'},
                {data: 'date'}
            ];

        $historyTable.DataTable({
            serverSide: true,
            processing: true,
            ajax: {
                url: '/api/thermometer-histories',
                headers: {
                    'Accept': 'application/ld+json'
                },
                data: function (data) {
                    data.page = data.start / data.length + 1;
                    data.itemsPerPage = data.length;

                    try {
                        data.order = data.order.reduce((result, item) => {
                            if ('date' === columns[item.column].data) {
                                columns[item.column].data = 'readAt';
                            }

                            result[columns[item.column].data] = item.dir;
                            return result;
                        }, {});
                    } catch (e) {
                        delete data.order;
                    }

                    data.search = data.search.value;

                    delete data.start;
                    delete data.length;
                    delete data.draw;
                    delete data.columns;
                    delete data._;
                },
                dataFilter: function (data) {
                    let json = JSON.parse(data);
                    json.recordsTotal = json['totalItems'];
                    json.recordsFiltered = json['totalItems'];
                    json.data = json['member'];

                    json.data.forEach(function (item) {
                        item.temp = item.temp + '°C';
                        item.hum = item.hum + '%';
                    });

                    return JSON.stringify(json);
                }
            },
            columns,
            order: [[3, 'desc']],
            language: {
                'url': '//cdn.datatables.net/plug-ins/1.11.4/i18n/pl.json'
            }
        });
    }

    // Ustawienia
    if (window.location.pathname === '/settings') {
        $main.on('change', '.settings .setting [type="checkbox"]', (e) => {
            let $checkbox = $(e.target),
                name = $checkbox.data('name'),
                value = $checkbox.prop('checked') ? '1' : null;

            apiPatch('/api/settings/' + name, {value})
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    return response.json();
                });
        });
    }
});

function apiPost(url, data) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

function apiPatch(url, data) {
    return fetch(url, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/merge-patch+json'
        },
        body: JSON.stringify(data)
    });
}

function apiGet(url) {
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
